/** Sync read of cached Orca user (avoids first-paint access gate with empty context). */
export function getStoredOrcaUser(): {
  _id?: string;
  userSubType?: string;
} | null {
  try {
    const raw = localStorage.getItem("ORCA_USER");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as { _id?: string; userSubType?: string };
  } catch {
    return null;
  }
}

export function isOrcaUserDetailsReady(
  userDetails: { _id?: string; userSubType?: string } | null | undefined,
): boolean {
  if (userDetails?._id || userDetails?.userSubType) return true;
  const stored = getStoredOrcaUser();
  return Boolean(stored?._id || stored?.userSubType);
}

export function resolveUserSubType(
  userDetails: { userSubType?: string } | null | undefined,
): string {
  const fromContext = String(userDetails?.userSubType ?? "").trim();
  if (fromContext) return fromContext;
  return String(getStoredOrcaUser()?.userSubType ?? "").trim();
}
